module.exports = __webpack_public_path__ + "static/img/3.eab88e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contact/3.jpg
// module id = bjre
// module chunks = 1